import React, { useEffect, useState } from "react";
import { getUserById } from "../api/api";
import { environment } from "../../environments/environments";
import "../RegistraionFlowHeader/RegistraionFlowHeader.css";
import Swal from "sweetalert2";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
const stepLabels = [
  "Registration",
  "Payment",
  "Image Upload",
  "Doc Upload",
  "Interests",
  "Questionnaires",
];

const RegistraionFlowHeader = () => {
  const [uservalue, setUservalue] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const storedUser = localStorage.getItem("currentUser");
        if (storedUser) {
          const userDatas = JSON.parse(storedUser);
          const _id = userDatas?.id || userDatas?._id;
          const currentUser = await getUserById({ user_id: _id });

          setUservalue(currentUser);

          let step = 1;
          const status = currentUser?.data?.profile_completion_status;

          switch (status) {
            case "Basic":
            case "RegistrationVarification":
              step = 1;
              break;
            case "paymentscreen":
            case "Payment":
              step = 2;
              break;
            case "gender":
            case "UploadImage":
              step = 3;
              break;
            case "uploadDocument":
              step = 4;
              break;
            case "cultureReligion":
            case "UpdateProfileDetails":
            case "UpdateMatchPreferences":
            case "interest":
            case "Lovelanguage":
              step = 5;
              break;
            case "userAnswersTemperament":
            case "userAnswersValue":
            case "userAnswersIQ":
              step = 6;
              break;
            // case "RegistrationVarification":
            //   step = 10;
            //   break;
            default:
              step = 1;
          }

          setCurrentStep(step);
        } else {
          setUservalue(null);
          setCurrentStep(1);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const profileStatus =
    uservalue?.data?.profile_completion_status?.toLowerCase();
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("currentUser");
        navigate("/login");
      }
    });
  };

  return (
    <div className="flowregistration-container">
      <div className="logout-icon-container" onClick={handleLogout}>
        <FiLogOut className="logout-icon" title="Logout" />
      </div>
      <div className="flowstep-container">
        {stepLabels.map((label, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber <= currentStep;

          const isQuestionStep = [
            "useranswerstemperament",
            "useranswersiq",
            "useranswersvalue",
          ].includes(profileStatus);
          const isErrorStep =
            (label === "Payment" && profileStatus === "paymentscreen") ||
            (label === "Image Upload" && profileStatus === "uploadimage") ||
            (label === "Doc Upload" && profileStatus === "uploaddocument") ||
            (label === "Interests" && profileStatus === "interest") ||
            (label === "Questionnaires" && isQuestionStep);

          const isCurrentStep =
            (label === "Registration" &&
              (profileStatus === "basic" ||
                profileStatus === "registrationvarification")) ||
            (label === "Questionnaires" && isQuestionStep) ||
            label.toLowerCase().replace(/\s/g, "") === profileStatus;

          return (
            <div key={index} className="flowstep-wrapper">
              <div className="flowstep-item">
                <div
                  className="flowstep-circle"
                  style={{
                    backgroundColor:
                      isCurrentStep || isCompleted
                        ? environment.teal
                        : "#d3d3d3",
                  }}
                />
                <p
                  className="flowstep-label"
                  style={{
                    color: isErrorStep
                      ? environment.teal
                      : isCompleted
                      ? environment.teal
                      : "#999",
                  }}
                >
                  {label}
                </p>
              </div>
              {index < stepLabels.length - 1 && (
                <div
                  className="flowline"
                  style={{
                    backgroundColor:
                      currentStep > index ? environment.teal : "#d3d3d3",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegistraionFlowHeader;
